<template>
  <div class="GirisSayfa">
    <div class="GirisCont">
      <el-row :gutter="24">
        <el-col :sm="24" :md="{span:6,offset:9}">
          <div class="GirisForm">
            <img src="https://cdn.mudu.pro/Design/mudu.svg" class="girislogo">

            <el-form v-loading="lo" status-icon :model="Form" @submit.prevent.native="Gonder" :rules="FormHata"
                     ref="Form">
              <el-form-item label="Telefon" prop="Telefon">
                <el-input type="tel" v-model="Form.Telefon" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="Parola" prop="Parola">
                <el-input type="password" v-model="Form.Parola" autocomplete="off" show-password></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="d-block" @click="Gonder()" :loading="lo">Gönder</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lo: false,
      Form: {
        Telefon: '',
        Parola: ''
      },
      FormHata: {
        Telefon: [{required: true, message: "Telefon Giriniz", trigger: 'blur'}],
        Parola: [{required: true, message: "Parola Giriniz", trigger: 'blur'}],
      },
    }
  },
  methods: {
    Gonder() {
      this.$refs['Form'].validate((valid) => {
        if (valid) {
          this.lo = true
          this.$store.dispatch("Post", {...this.Form, path: 'giris'})
              .then(response => {
                if (response.Durum == "OK") {

                  localStorage.setItem('_mudubo', JSON.stringify(response.Bilgi));
                  if (response.Bilgi.Proje) localStorage.setItem('_muduboProje', JSON.stringify(response.Bilgi.Proje));
                  // location.reload();
                  this.$router.push("/panel")
                  this.$notify.success({
                    title: response.Mesaj,
                    customClass:'success'
                  });
                  this.$store.dispatch("session", {ju: response.Bilgi, Proje: response.Bilgi.Proje})
                } else {
                  this.$notify.error({
                    title: response.Mesaj,
                    customClass:'error'
                  });
                  this.lo = false

                }
              })
        }
      })

    }
  }
}
</script>
<style>
.GirisSayfa {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #4285f4;
}

.GirisForm {
  text-align: center;

  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 4px 8px rgb(0 0 0 / 17%);
  background-color: #fbfbfb;
  padding: 20px;
}

.GirisCont {
  margin: auto;
  align-self: flex-start;
  width: 100%;
}

.girislogo {
  width: 60%;
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/Giris/Index.vue